import iWhitePolygon from "../../../../assets/icons/white-polygon.svg";
import iBlueRhombus from "../../../../assets/icons/blue-rhombus.svg";
import { formatNumber } from "../../../../utils";
import "./case-info.sass";

type Props = {
  bgColor?: "green-bg" | "blue-bg" | "light-blue-bg" | string;
  textColor?: "white" | "blue";
  value: string | number;
  text: string;
  isSm?: boolean;
  isRow?: boolean;
  textSize?: "12px" | "16px" | "24px";
  groupValueAndText?: boolean;
};

const CaseInfo = ({
  bgColor,
  value,
  text,
  textColor,
  isSm = false,
  isRow = false,
  textSize,
  groupValueAndText = false,
}: Props) => {
  const iconNode =
    bgColor === "light-blue-bg" && !isSm ? (
      <img src={iBlueRhombus} className="case-info__icon" alt="" />
    ) : bgColor !== "light-blue-bg" && bgColor && !isSm ? (
      <img src={iWhitePolygon} className="case-info__icon" alt="" />
    ) : null;

  const valueNode = (
    <div className={`case-info__value ${textColor ? textColor : ""}`}>
      {formatNumber(value)}
    </div>
  );

  const textNode = (
    <div
      className={`case-info__text ${textColor ? textColor : ""}`}
      style={textSize ? { fontSize: textSize } : undefined}
    >
      {text}
    </div>
  );

  return (
    <div className="case-info" style={{ backgroundColor: bgColor }}>
      {groupValueAndText ? (
        <div className="case-info__split">
          <div className="case-info__split-top">{iconNode}</div>
          <div className="case-info__split-bottom">
            <div className="case-info__text-group">
              {valueNode}
              {textNode}
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className={`case-info__block ${isRow ? "case-info__block--row" : ""}`}>
            {iconNode}
            {valueNode}
          </div>
          {textNode}
        </>
      )}
    </div>
  );
};

export default CaseInfo;
